import {put, call, cancel} from 'redux-saga/effects';
import Creators, {forgetPasswordFailed} from '../state/AppRedux';
import {assessmentService} from '../services/assessmentService';
import {validateFormErrorResponse} from '../helpers';
import {navigate} from 'gatsby';

// submit assessment
export function* submitAssessment(answers) {
    yield put(Creators.fetching());
    //
    let result = null;
    try {
        result = yield call(assessmentService.submitAssessmentRequest, answers);
        if (result.data.response) {
            yield put(Creators.submitFirstAssessmentPhaseSuccessfully(result.data.response));
        }
    } catch (e) {
        if (e.status === 401) {
            yield put(Creators.logout());
            navigate('/');
        }
        // const validationMessages = validateFormErrorResponse(e.answers.response);
        // yield put(Creators.updatePasswordFailed(validationMessages))
    }
}


// get all assessment questions
export function* getAllAssessment(data) {
    yield put(Creators.fetching());

    let result = null;
    try {
        result = yield call(assessmentService.getAssessment, data);
        console.log(result);
        if (result && result.data.response) {
            yield put(Creators.assessmentFetchedSuccessfully(result.data.response));
        }
    } catch (e) {
        if (e.status === 401 || e.status === 412) {
            yield put(Creators.logout());
            navigate('/login');
        }
        yield put(Creators.stopFetching());
    }
}
